import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ThemeService } from './theme.service';
import { GET_DASHBOARDS } from '../looker/queries';
import { ConfigAwareService } from "../config/models/config";
import { Apollo } from "apollo-angular";
import { getEmbedSDK, ILookerEmbedSDK, LookerEmbedExSDK } from "@looker/embed-sdk";
import { AuthService } from "@auth0/auth0-angular";
import { environment } from "../../../environments/environment";
import { lastValueFrom } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LookerService extends ConfigAwareService {

  private orgId = null;

  constructor(
    private themeService: ThemeService,
    private apollo: Apollo,
    private authService: AuthService,
  ) {
    super();
  }

  public init(orgId: string) {
    this.orgId = orgId
  }

  get theme(): string {
    return this.themeService.getCurrentThemeValue().lookerTheme;
  }

  getCustomDashboards(page = 1, pageSize = 50) {
    return this.apollo.watchQuery<any>({
      fetchPolicy: 'network-only',
      query: GET_DASHBOARDS,
      variables: {
        page,
        pageSize
      }
    }).valueChanges.pipe(
      map((result: any) => ({
        group: result.data.orgDashboards,
        personal: result.data.myDashboards
      })),
    )
  }

  async getSdk(orgId?: string): Promise<ILookerEmbedSDK> {
    const sdk = getEmbedSDK(new LookerEmbedExSDK());
    const token = await lastValueFrom(this.authService.getAccessTokenSilently({
      authorizationParams: {
        authorizationParams: (orgId != null ?? this.orgId) && { organization: orgId ?? this.orgId }
      },
    }));
    sdk.init(environment.lookerApiHost, {
      url: `${ this.baseUrl }auth`,
      headers: [{
        name: 'Authorization',
        value: `Bearer ${ token }`
      }]
    })
    return sdk;
  }


  async clearSession(orgId: string) {
    const sdk = await this.getSdk(orgId);
    sdk.clearSession();
  }
}

export class LookerResponse {
  public url = 'about:blank';
}
